import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {userSearchResultStateSelector} from './user-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {UserAudit} from 'src/openapi/admin/models/UserAudit';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

export const userSearchResultAuditSlice = getCachedTableDataSlice<
    Record<string, UserAudit>,
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userSearchResultAudit');

export const userSearchResultAuditActions = userSearchResultAuditSlice.actions;

const userSearchResultAuditCacheSelector: CachedTableCacheSelector<Record<string, UserAudit>>
    = state => state.userSearchResult.audit.cache;
export const userSearchResultAuditDataSelector: CachedTableDataSelector<Record<string, UserAudit>>
    = state => state.userSearchResult.audit;
export const userSearchResultAuditResultSelector = getCachedTableResultSelector(
    userSearchResultAuditCacheSelector,
    userSearchResultStateSelector,
);
